import { Injectable } from "@angular/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { lastValueFrom, map, Observable, of } from "rxjs";
import { ContractorsApi } from "../contractors.api";
import { SearchContractorsDto, SearchContractorsTypes } from "../dto/search-contractors.dto";
import { Contractors } from "../models/contractors.model";

export type ContractorsTypeaheadOptions = {
    type: SearchContractorsTypes;
};

@Injectable()
export class ContractorsTypeaheadApi extends NiceAsyncTypeaheadProvider<Contractors> {
    public override readonly resource = "contractors";

    private readonly pageSize = 20;

    constructor(private api: ContractorsApi) {
        super();
    }

    public override async getById(id: number): Promise<Contractors> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number,
        options?: ContractorsTypeaheadOptions
    ): Observable<NiceAsyncTypeaheadSearchResult<Contractors>> {
        if (!options?.type) {
            return of({
                items: [],
                nextPage: null
            });
        }

        const dto: SearchContractorsDto = {
            type: options.type,
            searchQuery,
            page,
            pageSize: this.pageSize
        };

        return this.api.getAll(dto).pipe(
            map(result => ({
                items: result,
                nextPage: result.length === this.pageSize ? page + 1 : null
            }))
        );
    }

    public override format(contractor: Contractors): string {
        return contractor.name;
    }
}
